const id_mitra_stock_req = {
    "": "permintaan barang",
    detail: "detail permintaan barang",
    add: "tambah permintaan barang",
    edit: "ubah permintaan barang",

    do_out: "buat barang keluar",
    do_in: "buat barang masuk",

    label: {
        requested_dest: "Pilih Tujuan Permintaan",
        requested_qty: "qty permintaan",
        date: 'Tanggal Target Dikirim',
    },

    print: {
        title: 'Detail Permintaan Stok',
        request_number: "nomor permintaan",
        requested_by: 'diminta oleh',
        requested_from: 'ditujukan kepada',
    },

    message: {
        delete_title: "Apakah Anda yakin untuk membatalkan permintaan barang?",
        delete_text: "Masukkan alasan pembatalan permintaan barang.",
        reject_title: "Apakah Anda yakin untuk menolak permintaan barang?",
        reject_text: "Masukkan alasan pembatalan permintaan barang.",
    },

    error: {
        create: "Gagal membuat permintaan barang",
        edit: "Gagal mengubah permintaan barang",

        done: "Gagal menyelesaikan permintaan barang",
        delete: "Gagal menghapus permintaan barang",
        reject: "Gagal menolak permintaan barang",
        approve: "Gagal mengkonfirmasi permintaan barang",

        date: 'Tanggal Target Dikirim tidak boleh kosong',
        mitra_dest: "Tujuan Permintaan tidak boleh kosong",
    },

    success: {
        create: "Berhasil membuat permintaan barang",
        edit: "Berhasil mengubah permintaan barang",

        done: "Berhasil menyelesaikan permintaan barang",
        delete: "Berhasil menghapus permintaan barang",
        reject: "Berhasil menolak permintaan barang",
        approve: "Berhasil mengkonfirmasi permintaan barang",
    },
}

export default id_mitra_stock_req;